import { combineReducers, configureStore } from '@reduxjs/toolkit';
import utlsSlice from './utlsSlice';
import newsSlice from './newsSlice';
import eventsSlice from './eventsSlice';
import learningsSlice from './learningsSlice';

const rootReducer = combineReducers({
	utlsSlice,
	news: newsSlice,
	events: eventsSlice,
	learnings: learningsSlice,
});

const store = configureStore({
	reducer: {
		reducer: rootReducer,
	},
	middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export type RootState = ReturnType<typeof store.getState>;

export default store;
